import { atom } from 'nanostores'

import type { LangCode } from '@/services/schemas'

export const $language = atom<LangCode>('en')
